import { useQueryParam } from 'labguard-cdk'

export default function useDisplayState() {
  return useQueryParam('display')
}
